import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { URLS } from '../../../constant/constant';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-expert-second-medical-opinion',
  templateUrl: './expert-second-medical-opinion.component.html',
  styleUrls: ['./expert-second-medical-opinion.component.css']
})
export class ExpertSecondMedicalOpinionComponent implements OnInit {
  constructor(private utilitiesService: UtilitiesService,
    private readonly providerstateService: ProviderStateService
  ) { }

  exploremore = true;
  is_uk_country: boolean = false;
  slug: string = "";
  is_primary_provider: boolean = false;
  ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
   this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    if(URLS.IS_UK)
    {
        this.is_uk_country = true;
    }
   
  }
  async openLink(base_url_name: string, link: string, target: string): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }
}
